module.exports = __webpack_public_path__ + "static/media/sample-batch-data-file.e3138b59.csv";